import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';
import {SkillsComponent} from "./skills.component";

@Component({
  selector: 'app-development-process',
  templateUrl: './development-process.component.html',
  styleUrls: ['./development-process.component.css']
})
export class DevelopmentProcessComponent implements OnInit {
  height: number;
  width: number;
  isFired: boolean = false;
  proportion: number = 0.677;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    let width = $(window).width();
    if (width > 800) {
    this.height = this.service.getHeight(this.proportion);
    } else  {
      this.height = this.service.getHeight(this.proportion * 1.1);
    }
  }

  onScroll(elementName: string) {
    if (!this.isFired){
       let inView = SkillsComponent.isElementInViewport($(elementName));

      if (inView) {
        $(elementName).addClass(elementName.substring(1, elementName.length) + '-animation');
      }
    }
  }

  kostil() {
    if (!this.isFired){
    let inView = SkillsComponent.isElementInViewport($('.secondPar'));

    if (inView) {
      this.isFired = true;
      $('.bottomPic').addClass('bottomPic-animation');
    }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/development-process.component.ts